import { List, Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'
import {
  ContactEmailAddress,
  IContactEmailAddress,
} from './ContactEmailAddress'

export interface IGroup {
  readonly associatedContacts: List<IAssociatedContact>
  readonly contactEmails: List<IContactEmailAddress>
  readonly groupId: string
  readonly id: string
  readonly name: string
}

const GroupRecord = Record({
  associatedContacts: List<AssociatedContact>(),
  contactEmails: List<ContactEmailAddress>(),
  groupId: '',
  id: '',
  name: '',
})

export class Group extends GroupRecord implements IGroup {
  public static fromJS(initialState?: Partial<IGroup>) {
    if (!initialState) {
      return new Group()
    }

    const { associatedContacts, contactEmails, ...rest } = initialState

    return new Group({
      associatedContacts: associatedContacts
        ? List(associatedContacts.map((a) => AssociatedContact.fromJS(a)))
        : undefined,
      contactEmails: contactEmails
        ? List(contactEmails.map((a) => ContactEmailAddress.fromJS(a)))
        : undefined,
      ...rest,
    })
  }

  public readonly associatedContacts: List<AssociatedContact>
  public readonly contactEmails: List<ContactEmailAddress>
  public readonly groupId: string
  public readonly id: string
  public readonly name: string

  constructor(props?: Partial<Group>) {
    props ? super(props) : super()
  }
}
